// extracted by mini-css-extract-plugin
export default {"container":"banner-view-modal_container__2BltK"};